<template>
  <div>
    <app-header />

    <div class="container container-fluid mt-4 mb-4">

      <h3>General Settings</h3>

      <ul class="nav nav-grid">
        <li class="nav-item col-6 col-md-4 col-xl-3">
          <router-link tag="a" class="nav-link" :to="{name: 'settings.phpinfo'}">
            <div>
              PHP Status
              <span class="description">PHP status &amp; configuration</span>
            </div>
          </router-link>
        </li>

        <li class="nav-item col-6 col-md-4 col-xl-3">
          <router-link tag="a" class="nav-link" :to="{name: 'settings.xero'}">
            <div>
              Xero
              <span class="description">Mange xero account settings</span>
            </div>
          </router-link>
        </li>

        <li class="nav-item col-6 col-md-4 col-xl-3">
          <router-link tag="a" class="nav-link" :to="{name: 'settings.project-agreements'}">
            <div>
              Project Agreements
              <span class="description">Mange global project agreements</span>
            </div>
          </router-link>
        </li>

        <li class="nav-item col-6 col-md-4 col-xl-3">
          <router-link tag="a" class="nav-link" :to="{name: 'settings.sign-request-templates'}">
            <div>
              Sign Request Templates
              <span class="description">Mange global templates</span>
            </div>
          </router-link>
        </li>
      </ul>

      <template v-if="$isA('admin')">
        <h3>AI</h3>

        <ul class="nav nav-grid">
          <li class="nav-item col-6 col-md-4 col-xl-3">
            <router-link tag="a" class="nav-link" :to="{name: 'settings.ai-history'}">
              <div>
                AI History
                <span class="description">Debug agent conversations &amp; tool calls</span>
              </div>
            </router-link>
          </li>
        </ul>
      </template>

      <h3>Opportunities</h3>

      <ul class="nav nav-grid">
        <li class="nav-item col-6 col-md-4 col-xl-3">
          <router-link tag="a" class="nav-link" :to="{name: 'settings.stage-lead-times'}">
            <div>
              Stage Lead Times
              <span class="description">Current lead times for each stage</span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

    import { isEqual, debounce } from 'lodash'
    import { mapState, mapActions } from 'vuex'

    import LaddaButton from 'components/form/input/ladda-button.vue'
    import { notify } from 'utils'

    export default {
        components: {
            LaddaButton,
        },

        data: function () {
            return {

            }
        },
        mounted: function() {

            var that = this;

        },
        created: function() {

        },

        watch: {

        },

        methods: {

        }
    }
</script>

<style scoped>

</style>
